export default "__VITE_ASSET__e0c39237__"